import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Importem les accions
import {
    estacioIntroduccioLocalitzacioModificarCoordenades,
    estacioIntroduccioLocalitzacioModificarAltitud
} from '../../actions/estacio';

// Importem els selectors
import { selectorMunicipisAmbCoordenadesIComarca } from '../../selectors/selector_municipis';
import {
    selectorLocalitzacioEditadesCoordenades,
    selectorLocalitzacioEditadesAltitud,
    selectorLocalitzacioEditadesErrorsCoordenades
} from '../../selectors/selector_estacio_formulari_dades';

// Importem els components;
import LocalitzacioIntroduccioCamps from '../commons/localitzacioIntroduccioCamps';
import LocalitzacioIntroduccioMapa from '../commons/localitzacioIntroduccioMapa';

class EstacioIntroduccioLocalitzacio extends Component {

    render() {
        const { municipis, coordenades, altitud, errorsCoordenades } = this.props;
        const { estacioIntroduccioLocalitzacioModificarCoordenades, estacioIntroduccioLocalitzacioModificarAltitud } = this.props;

        return (
            <div className='estacio-introduccio-localitzacio'>
                <LocalitzacioIntroduccioCamps
                    municipis={municipis}
                    coordenades={coordenades}
                    altitud={altitud}
                    errorsCoordenades={errorsCoordenades}
                    classeCss='localitzacio-introduccio-camps'
                    onChangeCoordenades={estacioIntroduccioLocalitzacioModificarCoordenades}
                    onChangeAltitud={estacioIntroduccioLocalitzacioModificarAltitud}
                />

                <LocalitzacioIntroduccioMapa
                    coordenades={coordenades}
                    classeCss='localitzacio-introduccio-mapa estacio-introduccio-localitzacio-mapa'
                    onChangeCoordenades={estacioIntroduccioLocalitzacioModificarCoordenades}
                    habilitarCoordenadesForaCatalunya={true}
                />
            </div>
        );
    }
}

EstacioIntroduccioLocalitzacio.propTypes = {
    municipis: PropTypes.object,
    coordenades: PropTypes.object,
    altitud: PropTypes.number,
    errorsCoordenades: PropTypes.object,
    estacioIntroduccioLocalitzacioModificarCoordenades: PropTypes.func,
    estacioIntroduccioLocalitzacioModificarAltitud: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        municipis: selectorMunicipisAmbCoordenadesIComarca(state),
        coordenades: selectorLocalitzacioEditadesCoordenades(state),
        altitud: selectorLocalitzacioEditadesAltitud(state),
        errorsCoordenades: selectorLocalitzacioEditadesErrorsCoordenades(state)
    };
};

export default connect(mapStateToProps, { estacioIntroduccioLocalitzacioModificarCoordenades, estacioIntroduccioLocalitzacioModificarAltitud })(EstacioIntroduccioLocalitzacio);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioLocalitzacio.js